// oauth config
import {OAuthConfig} from "@prowin/oauth2-client/lib/types";
import {OAuth} from "@prowin/oauth2-client";

const oauthConfig: OAuthConfig = {
    clientId: process.env.REACT_APP_OAUTH2_CLIENT_ID!,
    clientSecret: process.env.REACT_APP_OAUTH2_CLIENT_SECRET!,
    accessTokenUri: `${process.env.REACT_APP_OAUTH2_BASE_URI}${process.env.REACT_APP_OAUTH2_ACCESS_TOKEN_ENDPOINT}`,
    authorizationUri: `${process.env.REACT_APP_OAUTH2_BASE_URI}${process.env.REACT_APP_OAUTH2_AUTHORIZATION_ENDPOINT}`,
    revokeUri: `${process.env.REACT_APP_OAUTH2_BASE_URI}${process.env.REACT_APP_OAUTH2_REVOKE_ENDPOINT}`,
    redirectUri: `${process.env.REACT_APP_OAUTH2_REDIRECT_URI}${process.env.REACT_APP_OAUTH2_REDIRECT_ENDPOINT}`,
    logoutRedirectUri: `${process.env.REACT_APP_OAUTH2_LOGOUT_REDIRECT_URI}`,
    scopes: [process.env.REACT_APP_OAUTH2_SCOPES!],
    state: '', // will be generate in OAuth.createAuthIdentifier
    offlineModeAdditionalExpiredDays: 5, // 5 days is possible to use portal with expired token
    redirectPath: `${process.env.REACT_APP_OAUTH2_REDIRECT_ENDPOINT}`,
    switchLoginPath: `${process.env.REACT_APP_OAUTH2_SWITCH_LOGIN_PATH}`
}

// get oauth/user information from oauth

export function initOAuth(t?: <T>(key: T) => T): Promise<OAuth> {
    const oauth = new OAuth(oauthConfig);
    return oauth.setup()
        .then((oauthClient: any) => {
            if (oauthClient && oauthClient.isAuthenticated()) {
                const userType: string = 'pw_user_type';
                // Check user-type
                const jwtData =  oauthClient.getJwtData();
                if ( userType in jwtData) {
                    if (jwtData[userType] !== 'employee' && t) {
                        throw new Error(t("not_employee"));
                    }
                }
            }
            return oauthClient;
        }).catch((error: any) => {
            const oauthError: {error: any, oauth: OAuth} = {error, oauth};
            return Promise.reject(oauthError);
        });
}